"use client";

import React from "react"
import styled from "styled-components"
import Image from "next/image"
import { Label, P } from "@motorata/base-ui.components.atoms.typography";
import NextLink from "next/link"
import Link from "@motorata/next.components.atoms.link";
import { blockPadding } from "@motorata/base-ui.components.atoms._atoms";
import { buttonStyle, StyledButtonProps } from "@motorata/base-ui.components.atoms.button";
import Icon from "@motorata/base-ui.components.atoms.icon";
import { NewsletterInput } from "../sections/NewsletterSection"

const Footer = () => {
  return (
    <Wrapper>
      <Content>
        <div>
          <Image
            priority={true}
            height={55}
            width={200}
            alt="Logo MotoRata"
            src="/images/logo.png"
          />
          <P small>
            Na naszej platformie znajdziesz dziesiątki samochodów dostępnych w leasingu, pożyczce
            leasingowej lub kredycie prosto od dealerów oraz brokerów.
          </P>
          <P small margin="0" color="third">
            MotoRata Sp. z o.o.
          </P>
          <P small margin="0" color="third">
            ul. Gen. Józefa Sowińskiego 4
          </P>
          <P small margin="0" color="third">
            40-018 Katowice
          </P>
          <P small margin="0" color="third">
            NIP: 9542845141
          </P>
          <P small margin="0" color="third">
            KRS: 0000989900
          </P>
        </div>
        <div>
          <Label marginBottom="S" type="third" color="third">
            Menu
          </Label>
          <Link type="third" href="/oferty" marginBottom="S" padding="0">
            Wszystkie oferty
          </Link>
          <Link type="third" href="/komis-samochodowy" marginBottom="S" padding="0">
            Lista komisów samochodowych
          </Link>
          <Link type="third" href="/obserwowane" marginBottom="S" padding="0">
            Obserwowane oferty
          </Link>
          <Link type="third" href="/blog" marginBottom="S" padding="0">
            Blog
          </Link>
          <Link type="third" href="/dla-partnerow" marginBottom="S" padding="0">
            Dla partnerów
          </Link>
          {/*<SitemapLink type="third" rel="nofollow" href="https://pomoc.motorata.pl" marginBottom="S" padding="0">*/}
          {/*  Centrum pomocy*/}
          {/*</SitemapLink>*/}
          <Link type="third" href="/regulamin" marginBottom="S" padding="0">
            Regulamin
          </Link>
          <Link type="third" href="/polityka-prywatnosci" marginBottom="S" padding="0">
            Polityka prywatności
          </Link>
          <SitemapLink styledType="third" href="/sitemap-0.xml" target="_blank" marginBottom="S" padding="0">
            Sitemap
          </SitemapLink>
        </div>
        <div>
          <Label marginBottom="S" type="third" color="third">
            Finansowanie
          </Label>
          <Link type="third" href="/kalkulator-leasingowy" marginBottom="S" padding="0">
            Kalkulator leasingowy
          </Link>
          <Link type="third" href="/leasing" marginBottom="S" padding="0">
            Leasing samochodu
          </Link>
          <Link type="third" href="/leasing/samochod-uzywany" marginBottom="S" padding="0">
            Leasing samochodu używanego
          </Link>
          <Link type="third" href="/kredyt" marginBottom="S" padding="0">
            Kredyt na samochód
          </Link>
          <Link type="third" href="/kredyt/samochod-uzywany" marginBottom="S" padding="0">
            Kredyt na samochód używany
          </Link>
        </div>
        <div>
          <Label marginBottom="S" type="third" color="third">
            Kontakt
          </Label>
          <NewsletterInput type="secondary" />
          <Label marginBottom="S" marginTop="M" type="third" color="third">
            Śledź nas na
          </Label>
          <SocialWrapper>
            <NextLink target="_blank" href="https://www.facebook.com/motoratapl">
              <Icon height="25px" width="25px" icon="facebook" color="second" />
            </NextLink>
            <NextLink target="_blank" href="https://www.instagram.com/motorata.pl/">
              <Icon height="25px" width="25px" icon="instagram" color="second" />
            </NextLink>
            <NextLink target="_blank" href="https://www.tiktok.com/@motoratapl">
              <Icon height="25px" width="25px" icon="tiktok" color="second" />
            </NextLink>
          </SocialWrapper>
        </div>
      </Content>
      <FooterWrapper>
        <P textAlign="center" small margin="0">
          Powyższe oferty mają charakter informacyjny i nie stanowią oferty handlowej w rozumieniu
          art. 66 §1 Kodeksu Cywilnego”
        </P>
      </FooterWrapper>
    </Wrapper>
  )
}

export default Footer

const SitemapLink = styled.a<StyledButtonProps>`
  ${buttonStyle};
`

const FooterWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.space.S};
  padding-top: ${({ theme }) => theme.space.S};
  border-top: 1px solid ${({ theme }) => theme.color.backgroundDarker};
`

const SocialWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  grid-gap: ${({ theme }) => theme.space.M};
`

const Content = styled.div`
  width: 90%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  grid-gap: ${({ theme }) => theme.space.M};
  padding-bottom: ${({ theme }) => theme.space.M};

  img {
    margin-bottom: 20px;
    object-fit: contain;
    object-position: left;
  }

  > div:first-of-type {
    padding-right: 10%;
  }

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`

const Wrapper = styled.div`
  ${blockPadding};
  width: 100%;
  padding-bottom: 0px;
  background: ${({ theme }) => theme.color.background};
`
